import React from "react";
import CheckboxIcon from "@components/Icons/CheckboxIcon";
import "./style.scss";

const Checkbox = ({ id, checked, buttonAlignment = "left", onChange, children }) => {
    return (
        <div className={`checkbox__wrapper checkbox__wrapper--${buttonAlignment}`}>
            <div className="checkbox">
                <div className="checkbox__input-wrapper">
                    <input
                        id={id}
                        className="checkbox__input"
                        type="checkbox"
                        checked={checked}
                        onChange={onChange}
                        aria-labelledby={`${id}-label`}
                    />
                    <label htmlFor={id} className="checkbox__control" aria-hidden="true">
                        <CheckboxIcon className="checkbox__svg" />
                    </label>
                </div>
                <label htmlFor={id} id={`${id}-label`} className="checkbox__label">
                    {children}
                </label>
            </div>
        </div>
    );
};

export default Checkbox;
